import React from 'react';
import AdminTable from '../../admincomponents/AdminTable/AdminTable';
import Adminnav from '../../admincomponents/Adminnav/Adminnav';
import './AdminHome.css';
import OrderedTable from '../../admincomponents/OrderedTable/OrderedTable';


const AdminHome = () => {
  return (
    <div className="admin-home">
      <Adminnav/>
      <OrderedTable/>
    </div>
  );
};

export default AdminHome;
